import React from 'react';
import { Container, Box } from '@mui/material';
import SeismicMap from './components/SeismicMap';
import './App.css';

function App({ mountKey }) {
  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <h1>Calculadora de Parámetros Sísmicos</h1>
        <div key={mountKey}>
          <SeismicMap />
        </div>
      </Box>
    </Container>
  );
}

export default App;
